import script from "./CartOverview.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartOverview.vue?vue&type=script&lang=ts&setup=true"

import "./CartOverview.vue?vue&type=style&index=0&id=0ccaa5dd&lang=scss"

const __exports__ = script;

export default __exports__